var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlayIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 15 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5123 11.925L1.63738 21.8249C1.46306 21.9419 1.26175 22 1.06253 22C0.888217 22 0.711808 21.9548 0.554127 21.8657C0.211671 21.6724 0 21.3028 0 20.9V1.10026C0 0.697462 0.211671 0.327867 0.554127 0.13451C0.890308 -0.0566808 1.31156 -0.044924 1.63738 0.175348L16.5123 10.0752C16.8153 10.2771 17 10.6263 17 11.0001C17 11.3739 16.8153 11.723 16.5123 11.925Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlayIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/play-icon.3e6b34195495777fa53d9044bcef35f7.svg";